module.exports = __webpack_public_path__ + "assets/img/ic-type.8fe60748.svg";